module.exports = __webpack_public_path__ + "img/0Q3A2496_P_L_BlackMatted_MockedUp.41984222.jpg";